module.exports = __webpack_public_path__ + "static/media/pause-white-24px.6749dc92.svg";